import type { CmpHider } from './types';

export const cookiebot: CmpHider = {
  id: 'cookiebot',
  label: 'Cookiebot',
  css: `
      /* Cookiebot (Cybot, by Usercentrics): the entire consent UI lives in
         #CybotCookiebotDialog, with a separate fixed full-screen dimmer in
         #CybotCookiebotDialogBodyUnderlay. Hide both. Cookiebot also locks page
         scroll by setting an inline "overflow: hidden" on <html> (and sometimes
         <body>) rather than via a class, and that inline style is applied at
         runtime AFTER this style, so we out-specify it by leading with "html"
         and matching the inline lock with [style*="overflow"]. */
      #CybotCookiebotDialog,
      #CybotCookiebotDialogBodyUnderlay { display: none !important; }
      html[style*="overflow"],
      html body[style*="overflow"] {
        overflow: visible !important;
        position: static !important;
      }
  `,
};
